import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, OvertimeProvider } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant} from '../../../providers/';

import { Overtime } from '../overtime/page';
import { AppPresensi } from '../presensiApp/presensi';
import { UserPresensi } from '@providers/presensi';

@Component({
  selector: 'presensi-add-overtime',
  templateUrl: 'page.html'
})
export class AddOvertime {
  loading : any;
  formOvertime = {
    type:'',
    date:'',
    purpose:'',
  };
  configuration_form = {input_employee:false};
  parameter = {
    tanggal_mulai:null,
    tanggal_selesai:null,
    waktu_mulai:null,
    waktu_selesai:null,
    tugas:'',
    id:this.userApi.data.Employee_ID,
    name:this.userApi.data.Nama_Karyawan,
  };
  data = {

  };
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public userPresensi       : UserPresensi,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public overtimeProvider     : OvertimeProvider,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
  ) {
    this.config.set('backButtonText','Add Overtime');
  }

  ionViewDidEnter(){
    this.configuration_form.input_employee =  this.navParams.get('with_employee') === true ? true : false;
    if (this.navParams.get('with_employee')) {
      this.parameter['is_admin'] = 1;
    }
  }

  showEmployee(){
    let me = this;
    let params = {
      id: this.userApi.data.Employee_ID,
      all_data : this.userPresensi.akses['add_overtime_bawahan_hak_akses_data'],
    };
    this.helper.filterKaryawan(params, (karyawan) => {
      console.log(karyawan);
      if (karyawan=='me') {
        me.parameter.name = this.userApi.data.Nama_Karyawan; 
        me.parameter.id = this.userApi.data.user_id;
      }else{
        me.parameter.name = karyawan.employee_name; 
        me.parameter.id = karyawan.id;
      }
    });
  }

  
  submit(){
    let me = this;
    this.loading = this.helper.showLoading("Processing Data...");
    this.overtimeProvider.add_overtime(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        this.helper.presentSwal('Success','Your overtime has ben inserted','success');
        this.viewCtrl.dismiss();
        this.nav.setRoot(AppPresensi,{tabIndex:3});
      }else{
        this.helper.presentSwal('Failed',resp.msg,'warning');
        // this.viewCtrl.dismiss();
      }
    },(err) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/presensi/add_overtime/page.ts